import React from 'react';

export default function GlobalLoading({ isActive }) {
    if (!isActive) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex justify-center items-center z-[200] animate-fade-in transition-all duration-300">
            <div className="flex flex-col items-center">
                {/* Spinner moderno */}
                <div className="relative w-16 h-16 flex justify-center items-center">
                    <div className="absolute w-full h-full rounded-full border-4 border-white/10"></div>
                    <div className="absolute w-full h-full rounded-full border-4 border-blue-500 border-t-transparent animate-spin"></div>
                </div>
                
                {/* Texto opcional */}
                <p className="text-blue-400 font-semibold mt-4 tracking-wider animate-pulse text-sm">
                    CARREGANDO...
                </p>
            </div>
        </div>
    );
}
